module.exports = __webpack_public_path__ + "static/media/wir-suchen_2.896b2402.jpg";